import React from 'react'

export default function RandIcon({
  size = 24,
  strokeWidth = 2,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M7 21V3h6a5 5 0 0 1 0 10H7" />
      <path d="m12 13 6 8" />
    </svg>
  )
}
